import AssociationChicletAvatarOrIcon from './AssociationChicletAvatarOrIcon';
import AssociationChicletTitle from './AssociationChicletTitle';
import AssociationChicletActions from './AssociationChicletActions';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssociationChicletTitleContainer({
  association,
  chicletWidth
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    gap: "200",
    maxInlineSize: "100%",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexWrap: "nowrap",
      alignItems: "center",
      gap: "200",
      minInlineSize: "0",
      flex: 1,
      children: [/*#__PURE__*/_jsx(AssociationChicletAvatarOrIcon, {
        association: association
      }), /*#__PURE__*/_jsx(AssociationChicletTitle, {
        association: association
      })]
    }), /*#__PURE__*/_jsx(View, {
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(AssociationChicletActions, {
        association: association,
        chicletWidth: chicletWidth
      })
    })]
  });
}
export default AssociationChicletTitleContainer;